// extracted by mini-css-extract-plugin
module.exports = {"edit-trips__wrapper":"AccountEditTripsContainer_edit-trips__wrapper__RxYeS","edit-trips__trips-list":"AccountEditTripsContainer_edit-trips__trips-list__Olptc"};